module.exports = __webpack_public_path__ + "img/77a2aadea692a835870dfd58c653b77e.gif";